import React from 'react';
import { Container, Typography, Box } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';

const ManagedHomeFeed = () => {
  return (
    <Container maxWidth="sm">
      <Box mt={6}>
        <Alert severity="warning">This page has been moved.</Alert>

        <Box mt={2}>
          <Typography variant="body1">
            Please use the new link below:
          </Typography>

          <Typography variant="h6">
            <a
              href="https://whitelabel.sportvot.com/manage-home-feed/"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://whitelabel.sportvot.com/manage-home-feed/
            </a>
          </Typography>
        </Box>
      </Box>
    </Container>
  );
};

export default ManagedHomeFeed;
